/* eslint-disable react/display-name */
/* eslint-disable no-unused-vars */

import React, { useState, useEffect, useRef, forwardRef } from "react";
import PropTypes from "prop-types";
import ChartNode from "./ChartNode/ChartNode";
import "./ChartContainer.css";
import { useSelector } from "react-redux";

const propTypes = {
  // datasource: PropTypes.object.isRequired,
  chartClass: PropTypes.string,
  NodeTemplate: PropTypes.elementType,
  collapsible: PropTypes.bool,
  onClickNode: PropTypes.func,
};

const defaultProps = {
  containerClass: "",
  chartClass: "",
  collapsible: true,
};

// forwardRef is used to pass the ref of child to parent component
const ChartContainer = forwardRef(
  (
    {
      datasource,
      containerClass,
      chartClass,
      NodeTemplate,
      collapsible,
      meterData,
      rerenderFlag
    },
    ref
  ) => {
    const container = useRef();
    const chart = useRef();
    const [ds, setDS] = useState(datasource);

    const mode = useSelector((state) => state.darkMode);

const { isdarkMode } = mode;

    // console.log("ChartContainer:",datasource);
    const attachRel = (data, flags) => {
      if (!data) {
        return null; // Return null if data is undefined or null
      }

      data.relationship =
        flags + (data?.children && data?.children?.length > 0 ? 1 : 0);
      if (data.children) {
        data?.children?.forEach(function (item) {
          attachRel(item, "1" + (data?.children?.length > 1 ? 1 : 0));
        });
      }
      return data;
    };

    // whenever tha datasource changes update it to child.
    useEffect(() => {
      setDS(datasource);
    }, [datasource]);


    return (
      <>
        <div ref={container} className={`orgchart-container  ${containerClass} dark ${isdarkMode ? 'darkmode' : 'whitemode'}`} >
        {/* className={`orgchart-container ${containerClass} ${isdarkMode ? 'darkmode' : 'whitemode'}`} */}
          <div ref={chart} className={`orgchart  ${ chartClass} dark ${isdarkMode ? 'darkmode' : 'whitemode'}` }>
            <ul className={`orgchart  ${ chartClass} dark ${isdarkMode ? 'darkmode' : 'whitemode'}` }>
              <ChartNode
                datasource={attachRel(ds, "00")}
                NodeTemplate={NodeTemplate}
                collapsible={collapsible}
                meterData={meterData}
                key={rerenderFlag}
              />
            </ul>
          </div>
        </div>
      </>
    );
  }
);

ChartContainer.propTypes = propTypes;
ChartContainer.defaultProps = defaultProps;

export default ChartContainer;
